import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import { lazyGetBackgroundColorMenuItems } from 'owa-calendar-board-commanding';
import { changeBoardColorLabel } from 'owa-timestream-asset-sdk-color/lib/strings.locstring.json';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import loc from 'owa-localize';

export function getBackgroundColorMenuItem() {
    const getBackgroundColorMenuItems = lazyGetBackgroundColorMenuItems.tryImportForRender();
    const colorList: IContextualMenuItem[] = getBackgroundColorMenuItems
        ? getBackgroundColorMenuItems()
        : [];

    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(changeBoardColorLabel),
        [FilterableMenuItemArgs.icon]: ControlIcons.Color,
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.menuContent]: colorList,
    });
}
